import { PaymentType } from './common';
import { TargetUser } from '@/constants/coupon';
import { ActivationMode } from './member';

// 会员卡种信息
export type CardCategoryInfo = {
  merchant_id: number; // 商户ID为0表示系统预设的卡种，不可编辑
  id: number;
  name: string; // 卡种名称
  payment_type: PaymentType; // 支付类型
  intro: string;
};

/** 适用门店范围 */
export enum UseStoreScopeType {
  All = 'all',
  Selected = 'selected',
}

/** 是否启用可用时段限制 */
export enum TimeLimitEnabled {
  Disabled = 0,
  Enabled = 1,
}

/** 适用门店（响应对象） */
export type StoreRef = {
  store_id: number;
  store_name: string;
};

/** 可用时段规则 */
export type TimeRule = {
  weekdays: number[]; // 1-7 周一至周日
  start_time: string; // HH:mm
  end_time: string; // HH:mm
  match_type?: string; // 后端自动补，前端可不传
};

// 会员卡信息
export type MemberCardInfo = {
  id: number;
  merchant_id: number;
  name: string;
  member_card_type_id: number;
  member_card_type_name: string;
  num_of_times: number; // 次数
  validity_period: number; // 有效期 (天数)
  price: number; // 价格 (单位：分)
  discount_price: number; // 价格 (单位：分)
  purchase_limit?: number; // 购买限制
  user_sort?: number; // 用户端会员卡的排序
  visible_type: MemberCardVisible; // 用户端可见状态，1 表示可见，2不可见
  create_time: string; // 创建时间
  admin_status: MemberCardSaleStatus; // 会员卡状态 1 正常 2 下线
  payment_type: PaymentType; // 支付类型
  target_user: TargetUser; // 目标用户
  contract_template_id: number; // 电子合同 ID
  activate_type: ActivationMode; // 激活方式
  auto_activate_days?: number; // 自动激活天数
  book_limit_type?: number; // 预约频次限制类型
  book_limit?: number; // 预约频次限制值
  use_store_scope_type?: UseStoreScopeType; // 适用门店范围
  use_store_ids?: number[]; // 请求：指定门店 ID
  use_stores?: StoreRef[]; // 响应：指定门店对象数组
  time_limit_enabled?: TimeLimitEnabled; // 是否启用可用时段
  time_rules?: TimeRule[]; // 可用时段规则
};

// 会员卡在用户端是否可见
export enum MemberCardVisible {
  VISIBLE = 1, // 可见
  INVISIBLE = 2, // 不可见
}

// 会员卡在售状态
export enum MemberCardSaleStatus {
  NORMAL = 1, // 正常
  DELETED = 2, // 下线
}
